import React, { useCallback, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import { FORM_FIELDS_MAP } from 'features/sendouts/components/drawers/CreateSendoutDrawer/SendoutForm/SendoutForm.constants';
import strings from 'strings';
import { TimeSelect } from 'UI/components/molecules/TimeSelect';
import { REQUIRED_VALIDATION } from 'UI/utils';

import { getSuggestedInterviewTimes } from '../utils';

const STRINGS = strings.sendouts.form;

const validateTimeRange = ({ value, getValues }) => {
  if (!value) {
    return REQUIRED_VALIDATION.required;
  }

  const formValues = getValues();
  const fromHour = formValues[FORM_FIELDS_MAP.InterviewFromHour.key];
  const toHour = formValues[FORM_FIELDS_MAP.InterviewToHour.key];

  if (fromHour && toHour && fromHour >= toHour) {
    return STRINGS.errors.invalidTimeRange;
  }

  return true;
};

export const TimeRangeFields = () => {
  const { control, errors, getValues, triggerValidation } = useFormContext();

  const suggestedTimes = useMemo(getSuggestedInterviewTimes, []);

  const handleTimeChange = useCallback(
    ([value]) => {
      triggerValidation([
        FORM_FIELDS_MAP.InterviewFromHour.key,
        FORM_FIELDS_MAP.InterviewToHour.key
      ]);

      return value;
    },
    [triggerValidation]
  );

  return (
    <>
      <Grid item xs={6}>
        <Controller
          name={FORM_FIELDS_MAP.InterviewFromHour.key}
          control={control}
          rules={{
            ...REQUIRED_VALIDATION,
            validate: value => validateTimeRange({ value, getValues })
          }}
          defaultValue={suggestedTimes.from}
          as={
            <TimeSelect
              error={!!errors[FORM_FIELDS_MAP.InterviewFromHour.key]}
              errorText={errors[FORM_FIELDS_MAP.InterviewFromHour.key]?.message}
              name={FORM_FIELDS_MAP.InterviewFromHour.key}
              placeholder={STRINGS.labels.fromHour}
            />
          }
          onChange={handleTimeChange}
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          name={FORM_FIELDS_MAP.InterviewToHour.key}
          control={control}
          rules={{
            ...REQUIRED_VALIDATION,
            validate: value => validateTimeRange({ value, getValues })
          }}
          defaultValue={suggestedTimes.to}
          as={
            <TimeSelect
              error={!!errors[FORM_FIELDS_MAP.InterviewToHour.key]}
              errorText={errors[FORM_FIELDS_MAP.InterviewToHour.key]?.message}
              name={FORM_FIELDS_MAP.InterviewToHour.key}
              placeholder={STRINGS.labels.toHour}
            />
          }
          onChange={handleTimeChange}
        />
      </Grid>
    </>
  );
};
